// Amounts travel in cents; the dashboard shows dollars with two decimals.
export const formatCentsAsDollars = (cents: number): string => `$${(cents / 100).toFixed(2)}`;
